import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_accessible_fire_response_emergency_vehicles_although'

export const dataPointDefinition = {
  retracedId: 'facility_accessible_fire_response_emergency_vehicles_although',
  name: 'Is the facility accessible to fire response and emergency response vehicles, although there are no applicable legal requ',
  description:
    'The intent of this question is to understand if emergency response vehicles (such as fire trucks or ambulances) are able to access the facility.',
  meta: {
    slcpMeta: {
      key: 'hs-24--2',
      number: 'HS-EME-24',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-24--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29260,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
